import { StorageFile, StorageFileFormDefault } from "api/model/StorageFile";

export interface Car {
    id: string;
    brandId: string;
    name: string;
    model: string;
    description: string;
    carIRacingID: string;
    classIRacingID: string;
    className: string;
    image?: StorageFile;
}

export const CarFormDefault: Car = {
    id: "",
    brandId: "",
    name: "",
    model: "",
    description: "",
    carIRacingID: "",
    classIRacingID: "",
    className: "",
    image: StorageFileFormDefault,
};
